module.exports = __webpack_public_path__ + "static/icosahedron-1-390dadda0df5f34881a9d512093de0f4.png";